// French dictionary — translation of i18n.en.js. Keys missing here fall back to English.
export const fr = {
    // ---- General ----
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.continue": "Continuer",
    "common.delete": "Supprimer",
    "common.back": "Retour",
    "common.close": "Fermer",
    "common.send": "Envoyer",
    "common.loading": "Chargement…",
    "common.send_link": "M'envoyer un lien de connexion",

    // ---- Auth ----
    "auth.welcome_back": "Bon retour",
    "auth.welcome_subtitle": "Connectez-vous à {app}.",
    "auth.email": "Courriel",
    "auth.email_placeholder": "vous@famille.com",
    "auth.password": "Mot de passe",
    "auth.show": "Afficher",
    "auth.hide": "Masquer",
    "auth.keep_signed": "Rester connecté",
    "auth.forgot_password": "Mot de passe oublié ?",
    "auth.no_account": "Pas encore de compte ?",
    "auth.create_account": "Créer un compte",
    "auth.have_account": "Vous avez déjà un compte ?",
    "auth.sign_in": "Se connecter",
    "auth.sign_up_title": "Créez votre compte",
    "auth.sign_up_subtitle": "{app} fait tourner votre maison en silence.",
    "auth.your_name": "Votre nom",
    "auth.first_name": "Votre prénom",
    "auth.household_name": "Le nom de votre famille",
    "auth.household_optional": "Nous le générerons si vous laissez vide.",
    "auth.continue_email": "Continuer avec courriel",
    "auth.invite_join": "Vous rejoignez via une invitation",
    "auth.invite_code_label": "Code d'invitation",
    "auth.use_password": "Utiliser un mot de passe",
    "auth.use_magic": "Utiliser un lien magique",
    "auth.check_inbox": "Vérifiez votre boîte courriel",
    "auth.link_sent": "Lien de connexion envoyé à {email}. Cliquez dessus et vous êtes connecté.",
    "auth.fresh_link_sent": "Un nouveau lien arrive à {email}. Cliquez et vous y êtes.",
    "auth.signing_in": "Connexion…",
    "auth.almost_there": "Un instant, presque prêt.",
    "auth.link_failed": "Le lien n'a pas fonctionné",
    "auth.link_invalid": "Ce lien est invalide ou expiré.",
    "auth.send_fresh_to": "Envoyer un nouveau lien à :",
    "auth.email_fresh_link": "M'envoyer un nouveau lien",
    "auth.sending": "Envoi…",
    "auth.back_to_signin": "Retour à la connexion",
    "auth.welcome_question": "Bienvenue — comment doit-on vous appeler ?",
    "auth.first_time_caption": "Première connexion. Nous créons votre compte.",
    "auth.forgot_title": "Réinitialiser votre mot de passe",
    "auth.forgot_subtitle": "Entrez votre courriel — nous envoyons un lien.",
    "auth.reset_email_sent": "Vérifiez votre boîte — un lien arrive.",
    "auth.set_new_password": "Choisir un nouveau mot de passe",
    "auth.new_password": "Nouveau mot de passe",

    // ---- App shell / nav ----
    "nav.today": "Aujourd'hui",
    "nav.week": "Menu",
    "nav.shopping": "Courses",
    "nav.inventory": "Inventaire",
    "nav.chores": "Tâches",
    "nav.chat": "Discussion",
    "header.your_thread": "Votre fil avec Milo",

    // ---- Overflow menu ----
    "menu.invite_member": "Inviter un membre",
    "menu.refer_friend": "Parrainer un ami",
    "menu.feedback": "Envoyer un avis",
    "menu.telegram": "Rappels",
    "menu.pricing": "Forfaits et prix",
    "menu.manage_subscription": "Gérer l'abonnement",
    "billing.toast.success": "Paiement reçu — Milo Plus est maintenant actif. 🎉",
    "billing.toast.pending": "Paiement terminé. Confirmation à venir.",
    "billing.toast.confirm_failed": "Impossible de confirmer la session Stripe",
    "billing.toast.cancelled": "Paiement annulé. Vous pouvez réessayer depuis Forfaits et prix.",
    "billing.toast.no_customer": "Aucun abonnement Stripe pour l'instant. Rendez-vous sur Forfaits et prix pour commencer.",
    "billing.toast.portal_failed": "Impossible d'ouvrir le portail de facturation",
    "pricing.current_plan": "Forfait actuel",
    "pricing.cta_active": "Vous êtes sur ce forfait",
    "pricing.checking_out": "Redirection vers Stripe…",
    "pricing.checkout_failed": "Impossible de démarrer le paiement. Veuillez réessayer.",
    "plan.your_plan": "Votre forfait",
    "plan.free": "Gratuit",
    "plan.plus": "Milo Plus",
    "plan.premium": "Milo Premium",
    "plan.trial": "Essai",
    "plan.active": "Actif",
    "menu.set_password": "Définir un mot de passe",
    "menu.admin": "Admin",
    "menu.language": "Langue",
    "menu.sign_out": "Se déconnecter",

    // ---- Welcome card ----
    "welcome.eyebrow": "Bienvenue",
    "welcome.headline": "Bonjour {name} — voici ce que je peux faire pour {household}.",
    "welcome.subline": "Choisissez un démarrage ci-dessous, ou parlez-moi. La plupart des familles s'y mettent en moins de 5 minutes.",
    "welcome.dismiss": "Masquer",
    "welcome.starter.plan_dinners": "Planifier les dîners cette semaine",
    "welcome.starter.plan_dinners_sub": "Touchez un jour, ajoutez un repas",
    "welcome.starter.add_shopping": "Ajouter à la liste de courses",
    "welcome.starter.add_shopping_sub": "Une liste partagée, sans doublons",
    "welcome.starter.first_chore": "Créer une tâche récurrente",
    "welcome.starter.first_chore_sub": "Sortir les poubelles, aspirer, factures…",
    "welcome.talk": "Ou parlez simplement à Milo",

    // ---- Today tab ----
    "today.eyebrow_prefix": "Aujourd'hui",
    "today.title": "Voici votre journée",
    "today.loading": "Chargement…",
    "today.chip.meal_assigned": "Repas prévu",
    "today.chip.no_meal": "Aucun repas",
    "today.chip.chores_due": "{n} tâches à faire",
    "today.chip.chore_due": "{n} tâche à faire",
    "today.chip.shopping_items": "{n} articles à acheter",
    "today.chip.shopping_item": "{n} article à acheter",
    "today.todays_meal": "Repas du jour",
    "today.nothing_planned": "Rien de prévu",
    "today.tell_milo": "Dites à Milo ce qu'on cuisine",
    "today.cook_label": "Cuisine : {name}",
    "today.chores_due_today": "Tâches à faire aujourd'hui",
    "today.see_all": "Voir tout",
    "today.shopping_preview": "Aperçu des courses",
    "today.open_list": "Ouvrir la liste",
    "today.nothing_pressing": "Rien d'urgent. Respirez.",
    "today.nothing_needed": "Rien à acheter.",
    "today.more_count": "+{n} de plus",
    "today.urgent": "Urgent",
    "today.greeting_morning": "Bonjour {name}",
    "today.greeting_afternoon": "Bon après-midi {name}",
    "today.greeting_evening": "Bonsoir {name}",

    // ---- Week tab ----
    "week.eyebrow": "Menu sur deux semaines",
    "week.title": "Le menu de la semaine",
    "week.loading": "Chargement de la semaine…",
    "week.this_week": "Cette semaine",
    "week.next_week": "Semaine prochaine",
    "week.today_marker": "aujourd'hui",
    "week.add_meal": "+ Ajouter un repas",
    "week.role.cook": "Cuisine",
    "week.role.asst_cook": "Aide cuisine",
    "week.role.dishes": "Vaisselle",
    "week.role.asst_dishes": "Aide vaisselle",
    "week.placeholder_meal": "Soirée pâtes",
    "week.select.cook": "Cuisine…",
    "week.select.dishes": "Vaisselle…",
    "week.select.asst_cook": "Aide cuisine…",
    "week.select.asst_dishes": "Aide vaisselle…",
    "week.add_assistants": "+ Ajouter des aides",
    "week.recipe_placeholder": "Recette / notes (optionnel)",
    "week.saved": "{day} enregistré",
    "week.assistant": "Assistant",

    // ---- Shopping ----
    "shop.eyebrow": "Courses",
    "shop.title": "De quoi avons-nous besoin",
    "shop.add_placeholder": "Lait, œufs, pain…",
    "shop.add_btn": "Ajouter",
    "shop.any_store": "Tout magasin",
    "shop.add_store_option": "+ Ajouter un magasin…",
    "shop.any_category": "Toute catégorie",
    "shop.personal_label": "Personnel — visible par moi seul",
    "shop.personal_label_short": "Personnel — visible par moi seul",
    "shop.store_name_placeholder": "Nom du magasin (ex. Carrefour)",
    "shop.store_added": "Magasin ajouté",
    "shop.couldnt_add_store": "Impossible d'ajouter le magasin",
    "shop.sort_label": "Trier :",
    "shop.sort_label_short": "Trier",
    "shop.sort.newest": "Récents",
    "shop.sort.oldest": "Anciens",
    "shop.sort.store": "Magasin",
    "shop.sort.category": "Catégorie",
    "shop.sort.alpha": "A–Z",
    "shop.sort.user": "Membre",
    "shop.bought": "Achetés",
    "shop.bought_this_week": "Achetés cette semaine",
    "shop.bought_filter.this_week": "Cette semaine",
    "shop.bought_filter.last_week": "Semaine dernière",
    "shop.bought_filter.overall": "Total",
    "shop.bought_filter.avg_per_week": "Moy. / semaine",
    "shop.empty": "Votre liste de courses est vide.",
    "shop.empty_fridge": "Vide. Le frigo doit déborder.",
    "shop.missing_count": "Articles manquants ({n})",
    "shop.no_period": "Aucun article sur cette période.",
    "shop.avg_per_week_label": "articles / semaine (moy.)",
    "shop.tag_later": "Marquer plus tard",
    "shop.untagged": "Étiquette retirée",
    "shop.tagged_later": "Marqué pour plus tard",
    "shop.removed": "Supprimé",
    "shop.updated": "Mis à jour",
    "shop.couldnt_update_item": "Impossible de mettre à jour l'article",
    "shop.badge.personal": "perso",
    "shop.badge.later": "plus tard",
    "shop.cat.Produce": "Fruits & légumes",
    "shop.cat.Dairy": "Crèmerie",
    "shop.cat.Meat": "Viande",
    "shop.cat.Pantry": "Épicerie",
    "shop.cat.Frozen": "Surgelés",
    "shop.cat.Bakery": "Boulangerie",
    "shop.cat.Beverages": "Boissons",
    "shop.cat.Other": "Autre",
    "shop.show_label": "Afficher",
    "shop.uncategorised": "Sans catégorie",
    "shop.tag.groceries": "Épicerie",
    "shop.tag.personal": "Perso",
    "shop.tag.later": "Plus tard",
    "shop.tag.priority": "Priorité",
    "shop.tag.home": "Maison",
    "shop.fix_btn": "Fixer ma liste",
    "shop.fix_btn_working": "Analyse…",
    "shop.fix_banner_one": "1 article est déjà dans le garde-manger.",
    "shop.fix_banner_other": "{n} articles sont déjà dans le garde-manger.",
    "shop.fix_check_all": "Tout cocher",
    "shop.fix_dismiss": "Ignorer",
    "shop.fix_checked_toast_one": "1 article coché",
    "shop.fix_checked_toast_other": "{n} articles cochés",
    "shop.fix_no_matches": "Rien en stock — votre liste est propre.",
    "shop.in_pantry": "En stock",
    "shop.in_pantry_at": "En stock · {location}",
    "shop.badge.priority": "Priorité",
    "shop.badge.home": "Maison",
    "recipes.title": "Recettes de famille",
    "recipes.eyebrow": "Livre de recettes",
    "recipes.add": "Ajouter une recette",
    "recipes.empty": "Aucune recette pour l'instant. Ajoutez vos plats préférés — ils apparaîtront dans le menu avec leurs notes et liens.",
    "recipes.name": "Nom",
    "recipes.name_placeholder": "ex. Lasagne de grand-maman",
    "recipes.url": "URL de la recette",
    "recipes.url_placeholder": "https://…",
    "recipes.notes": "Notes",
    "recipes.notes_placeholder": "Ingrédients, astuces, variantes de la famille…",
    "recipes.rate": "Noter",
    "recipes.your_rating": "Votre note",
    "recipes.avg_rating": "Moyenne",
    "recipes.ratings_count_one": "{n} note",
    "recipes.ratings_count_other": "{n} notes",
    "recipes.no_ratings": "Aucune note",
    "recipes.delete_confirm": "Supprimer cette recette ? Les membres perdront leurs votes.",
    "recipes.deleted": "Recette supprimée",
    "recipes.saved": "Recette enregistrée",
    "recipes.search_placeholder": "Rechercher une recette…",
    "recipes.book_button": "Livre de recettes",
    "inventory.title": "Inventaire de cuisine",
    "inventory.eyebrow": "Garde-manger · frigo · congélateur",
    "inventory.shop_button": "Inventaire",
    "inventory.add_item": "Ajouter un article",
    "inventory.add_location": "Ajouter un espace",
    "inventory.empty_location": "Rien ici pour l'instant. Appuyez sur Ajouter un article pour commencer.",
    "inventory.empty_household": "Suivez ce qu'il y a dans le frigo, le garde-manger et le congélateur pour que Milo puisse optimiser votre liste d'épicerie et votre menu.",
    "inventory.all_tab": "Tout",
    "inventory.fields.name": "Article",
    "inventory.fields.name_placeholder": "ex. Lait, Poulet, Riz",
    "inventory.fields.quantity": "Quantité",
    "inventory.fields.unit": "Unité",
    "inventory.fields.category": "Catégorie",
    "inventory.fields.location": "Emplacement",
    "inventory.fields.expiration": "Expire le",
    "inventory.fields.use_soon": "À consommer avant",
    "inventory.fields.notes": "Notes",
    "inventory.fields.notes_placeholder": "Marque, magasin, fraîcheur…",
    "inventory.location_name": "Nom de l'espace",
    "inventory.location_name_placeholder": "ex. Frigo 2, Sous-sol, Garage",
    "inventory.location_icon": "Emoji (facultatif)",
    "inventory.delete_location_confirm": "Supprimer cet espace ? Les articles à l'intérieur seront supprimés sauf si vous les déplacez d'abord.",
    "inventory.delete_location_with_items": "Cet espace contient {n} article(s). Choisissez où les déplacer :",
    "inventory.delete_item_confirm": "Supprimer cet article de l'inventaire ?",
    "inventory.sort.recent": "Récents",
    "inventory.sort.expiring": "Expirent",
    "inventory.sort.alpha": "Nom",
    "inventory.sort.category": "Catégorie",
    "inventory.expired": "Expiré",
    "inventory.expires_today": "Expire aujourd'hui",
    "inventory.expires_in_days": "dans {n} j",
    "inventory.use_soon_in_days": "à utiliser dans {n} j",
    "inventory.search_placeholder": "Rechercher…",
    "inventory.quick_add_label": "Ajout rapide",
    "inventory.quick_added": "ajouté",
    "inventory.tab_eyebrow": "Inventaire",
    "inventory.tab_title": "Qu'avons-nous",
    "inventory.add_placeholder": "Ajouter un article (ex. Lait)",
    "inventory.add_btn": "Ajouter",
    "inventory.open_shopping_btn": "Liste de courses",
    "inventory.rename_hint": "Cliquer pour renommer",
    "inventory.show_label": "AFFICHER",
    "inventory.sort_label": "TRIER",
    "menu.inventory": "Inventaire de cuisine",
    "menu.recipes": "Recettes de famille",
    "week.save_as_recipe": "Enregistrer comme recette de famille",
    "week.recipe_url_label": "URL de la recette",
    "week.notes_label": "Notes",
    "week.open_recipe": "Ouvrir la recette ↗",
    "week.pick_recipe": "📖 Choisir une recette",
    "week.pick_for_me_btn": "🎲 Choisis pour moi",
    "week.pick_for_me_working": "Sélection…",
    "week.pick_for_me_failed": "Aucune recette trouvée — réessayez",
    "week.pick_for_me_from_vault": "De vos recettes : {name}",
    "week.pick_for_me_from_web": "Idée fraîche : {name}",
    "week.servings_label": "Portions",
    "week.servings_default_hint": "par défaut {n}",
    "week.add_to_shopping": "+ Ajouter les ingrédients aux courses",
    "week.add_week_to_shopping": "+ Ajouter toute la semaine aux courses",
    "week.ingredients_count_one": "{n} ingrédient",
    "week.ingredients_count_other": "{n} ingrédients",
    "week.steps_count_one": "{n} étape",
    "week.steps_count_other": "{n} étapes",
    "week.ai_generated_badge": "🤖 Suggestion IA",
    "week.ai_generated_hint": "Générée par IA — aucune source web vérifiée",
    "week.no_ingredients": "Aucun ingrédient sur cette recette",
    "week.no_recipe_link": "Liez d'abord une recette pour ajouter ses ingrédients",
    "week.added_to_shopping": "{added} ajoutés, {merged} fusionnés",
    "week.week_added_to_shopping": "Courses prêtes : {added} ajoutés · {merged} fusionnés",
    "week.picker_title": "Choisir une recette",
    "week.picker_empty": "Aucune recette pour l'instant. Ajoutez-en dans le livre de recettes.",
    "week.picker_search": "Rechercher…",
    "week.hh_servings_label": "Portions du foyer",
    "week.hh_servings_help": "Pour combien de personnes vous cuisinez d'habitude. Les recettes seront mises à l'échelle.",
    "week.hh_servings_saved": "Portions par défaut enregistrées",
    "week.fix_btn": "Régler le menu de la semaine",
    "week.fix_btn_working": "Planification…",
    "week.fix_settings_btn": "Réglages du menu",
    "week.fix_overwrite_label": "Remplacer les repas déjà prévus cette semaine",
    "week.fix_admin_only": "Seul l'admin du foyer peut lancer Fixer le menu",
    "week.fix_done": "Semaine prête : {vault} de vos recettes · {web} idées du web",
    "week.fix_none": "Tous les jours sont déjà prévus. Cochez « Remplacer » pour régénérer.",
    "week.fix_reshuffle_prompt": "Tous les jours sont prévus. Tout mélanger à nouveau ?",
    "week.fix_reshuffle_now": "Mélanger",
    "week.fix_settings_title": "Fixer le menu — réglages",
    "week.fix_vault_ratio_label": "Mélange de vos recettes vs. idées neuves",
    "week.fix_vault_ratio_hint": "{vault}% de votre livre de recettes · {web}% nouvelles idées du web",
    "week.fix_priorities_label": "Ce qui compte le plus",
    "week.fix_priorities_hint": "Chaque priorité est pondérée de 0 (ignorer) à 10 (priorité maximale). Plus le chiffre est élevé, plus Milo en tient compte.",
    "week.fix_priority.uses_expiring": "Utiliser ce qui périme bientôt",
    "week.fix_priority.high_rated": "Choisir vos recettes les mieux notées",
    "week.fix_priority.avoid_recent": "Éviter les repas récents",
    "week.fix_priority.uses_inventory": "Utiliser ce qui est déjà en stock",
    "week.fix_priority.balance_cooks": "Partager la cuisine entre membres",
    "week.fix_settings_saved": "Réglages enregistrés",
    "week.fix_auto_check_label": "Cocher automatiquement les articles déjà en stock",
    "week.fix_auto_check_hint": "Quand activé, « Fixer ma liste » coche silencieusement les articles trouvés en stock.",
    "week.hh_settings_title": "Réglages du foyer",
    "week.roles_section_title": "Attribuer les rôles automatiquement",
    "week.roles_section_hint": "Lors de « Fixer le menu », les rôles tournent entre les membres éligibles.",
    "week.role_toggle.auto_assign_cook": "Attribuer le chef cuisinier",
    "week.role_toggle.auto_assign_asst_cook": "Attribuer l'assistant cuisinier",
    "week.role_toggle.auto_assign_dishwasher": "Attribuer la vaisselle principale",
    "week.role_toggle.auto_assign_asst_dishwasher": "Attribuer l'assistant vaisselle",
    "week.role_toggle.cook_dish_must_differ": "Cuisinier et vaisselle doivent différer",
    "week.role_toggle.cook_dish_must_differ_hint": "Jamais la même personne ne cuisine ET ne fait la vaisselle le même soir.",
    "week.family_section_title": "Rôles de la famille",
    "week.family_section_hint": "Choisissez ce que chaque membre peut faire. Les enfants qui ne cuisinent pas sont exclus du tour de rôle.",
    "week.member.can_cook": "Cuisine",
    "week.member.can_dish": "Vaisselle",
    "week.scrape_title": "Recettes web",
    "week.scrape_hint": "Récupère les vrais ingrédients depuis l'URL source (+5s, plus précis).",
    "week.scrape_toggle": "Extraire les ingrédients depuis les URLs",
    "week.allow_no_url_toggle": "Autoriser les recettes IA sans URL vérifiée",
    "week.allow_no_url_hint": "Désactivé (par défaut) : Milo ne garde que les recettes web avec un lien valide. Activé : les recettes générées par IA sans lien sont aussi acceptées.",
    "week.favorite_site_label": "Site de cuisine préféré (URL)",
    "week.favorite_site_placeholder": "https://www.ricardocuisine.com",
    "week.favorite_site_hint": "Si défini, Milo privilégiera les recettes de ce site lors de « Régler le menu de la semaine ». Laissez vide pour piocher dans n'importe quel site de cuisine reconnu.",
    "week.favorite_sites_label": "Sites de cuisine préférés (classés)",
    "week.favorite_sites_hint": "Ajoutez jusqu'à 10 sites en ordre de priorité. #1 = préférence la plus forte, puis #2, etc. Utilisez les flèches pour réordonner. Laissez vide pour piocher dans n'importe quel site reconnu.",
    "week.favorite_site_invalid": "L'URL doit commencer par http:// ou https://",
    "week.erase_recipe_btn": "Effacer le contenu de la recette",
    "week.erase_recipe_confirm": "Effacer le nom du repas, l'URL, les notes, les ingrédients et les étapes pour cette journée ?",
    "week.save_to_vault_btn": "⭐ Enregistrer dans mes recettes",
    "week.save_to_vault_saved": "Ajouté à votre livre de recettes",
    "week.save_to_vault_already": "Déjà dans votre livre de recettes",
    "week.in_vault_badge": "📖 Dans le livre de recettes",
    // ---- Ingredients editor (Recipe book) ----
    "recipes.servings_label": "Cette recette donne",
    "recipes.servings_unit": "portions",
    "recipes.ingredients_title": "Ingrédients",
    "recipes.ingredients_help": "Ajoutez ce qu'il faut. Les quantités sont auto-ajustées aux portions du foyer lors de l'ajout aux courses.",
    "recipes.add_ingredient": "+ Ajouter un ingrédient",
    "recipes.ingredient_name": "Ingrédient",
    "recipes.ingredient_qty": "Qté",
    "recipes.ingredient_unit": "Unité",
    "recipes.ingredient_category": "Catégorie",
    "recipes.ingredient_remove": "Retirer",
    "recipes.unit.g": "g",
    "recipes.unit.kg": "kg",
    "recipes.unit.ml": "ml",
    "recipes.unit.l": "L",
    "recipes.unit.pcs": "pcs",
    "recipes.unit.tbsp": "c. à s.",
    "recipes.unit.tsp": "c. à c.",
    "recipes.unit.cup": "tasse",
    "recipes.unit.can": "boîte",
    "recipes.unit.bag": "sac",
    "recipes.unit.other": "autre",
    "recipes.steps_title": "Étapes",
    "recipes.steps_help": "Ajoutez les instructions, une par ligne. Importer une URL les remplit automatiquement.",
    "recipes.add_step": "+ Ajouter une étape",
    "recipes.step_placeholder": "Décrivez cette étape…",
    "recipes.step_remove": "Retirer",

    // ---- Chores ----
    "chores.eyebrow": "Tâches",
    "chores.title": "Qui fait quoi",
    "chores.add_placeholder": "Ajouter une tâche, ex. sortir les poubelles…",
    "chores.add_btn": "Ajouter",
    "chores.assign_to": "Assigner à…",
    "chores.unassigned": "Non assigné",
    "chores.recurrence.none": "Tâche unique",
    "chores.recurrence.daily": "Tous les jours",
    "chores.recurrence.weekly": "Toutes les semaines",
    "chores.recurrence.biweekly": "Toutes les 2 semaines",
    "chores.recurrence.monthly": "Tous les mois",
    "chores.filter.all": "Toutes",
    "chores.filter.mine": "À moi",
    "chores.filter.done": "Faites",
    "chores.added": "Tâche ajoutée",
    "chores.added_recurring": "Tâche récurrente ajoutée ({rec})",
    "chores.empty": "Rien en attente.",
    "chores.section.due_today": "Aujourd'hui",
    "chores.section.tomorrow": "Demain",
    "chores.section.upcoming": "À venir",
    "chores.save": "Enregistrer",
    "chores.needs_title": "Donnez un titre à la tâche",
    "chores.couldnt_update": "Impossible de mettre à jour la tâche",
    "chores.pushed_tomorrow": "Reporté à demain",
    "chores.updated": "Tâche mise à jour",
    "chores.clean_slate": "Tout est clean",
    "chores.empty_subtitle": "Rien sur la liste. Profitez du calme.",
    "chores.completed_count": "Faites ({n})",
    "chores.no_completed": "Aucune tâche faite pour l'instant.",
    "chores.urgent": "Urgent",
    "chores.edit_tooltip": "Modifier",
    "chores.snooze_tooltip": "+1 jour",
    "chores.repeats_tooltip": "Récurrence : {rec}",

    // ---- Chat ----
    "chat.eyebrow": "Votre fil avec Milo",
    "chat.title": "Parlez simplement",
    "chat.placeholder": "Message à la famille…",
    "chat.empty": "Salut — essayez de me demander de planifier le dîner, ou « ajoute du lait à la liste ».",
    "chat.suggestions_intro": "Essayez par exemple :",
    "chat.suggestion.add_milk": "Ajouter du lait",
    "chat.suggestion.whats_dinner": "Qu'est-ce qu'on mange ?",
    "chat.suggestion.show_shopping": "Voir la liste de courses",
    "chat.suggestion.laundry_done": "Lessive faite",
    "chat.suggestion.show_week": "Voir la semaine",
    "chat.error_milo_sleeping": "Milo dort. Réessayez.",
    "chat.voice.unsupported": "Voix non prise en charge ici. Essayez Chrome, Edge ou Safari.",
    "chat.voice.https": "La voix nécessite HTTPS. Ouvrez l'URL déployée dans un nouvel onglet.",
    "chat.voice.not_allowed": "Micro bloqué. Si vous êtes dans un panneau d'aperçu, ouvrez l'URL dans un nouvel onglet et autorisez le micro.",
    "chat.voice.service_not_allowed": "Micro bloqué par les réglages du navigateur ou de l'OS.",
    "chat.voice.no_speech": "Je n'ai rien entendu — réessayez.",
    "chat.voice.audio_capture": "Aucun micro détecté.",
    "chat.voice.network": "Erreur réseau pour la reconnaissance vocale.",
    "chat.voice.cant_start": "Impossible de démarrer le micro.",

    // ---- Feedback dialog ----
    "feedback.title": "Donnez-nous votre avis",
    "feedback.subtitle": "Nous lisons chaque réponse.",
    "feedback.placeholder": "Qu'est-ce qui marche ? Qu'est-ce qui manque ?",
    "feedback.bug": "Signaler un bug",
    "feedback.feature": "Demande de fonctionnalité",
    "feedback.send": "Envoyer",
    "feedback.sent": "Merci — bien reçu.",

    // ---- Invite & refer ----
    "invite.title": "Inviter un membre de la famille",
    "invite.subtitle": "Partagez ce code ou ce lien.",
    "invite.copy": "Copier",
    "invite.copied": "Copié dans le presse-papiers",
    "refer.title": "Parler de Milo à un ami",
    "refer.subtitle": "Nous adorerions rencontrer plus de familles.",

    // ---- Set password ----
    "setpw.title": "Définir un mot de passe",
    "setpw.subtitle": "Optionnel — pour des connexions plus rapides.",
    "setpw.success": "Mot de passe défini. Vous pouvez maintenant vous connecter avec courriel + mot de passe.",

    // ---- Pricing page ----
    "pricing.eyebrow": "Forfaits",
    "pricing.headline": "Une tarification simple pour chaque famille",
    "pricing.subline": "Commencez gratuitement. Passez au niveau supérieur quand vous êtes prêt à laisser Milo réfléchir pour vous.",
    "pricing.most_popular": "Le plus populaire",
    "pricing.per_month": "par mois",
    "pricing.compare_title": "Comparer les fonctionnalités",
    "pricing.col_feature": "Fonctionnalité",
    "pricing.footer": "Abonnements bientôt disponibles. Pendant l'essai, tout le monde a accès complet.",
    "pricing.cta_continue_free": "Continuer gratuitement",
    "pricing.cta_try_plus": "Essayer Milo Plus",
    "pricing.cta_join_waitlist": "Rejoindre la liste",
    "pricing.tier.free.name": "Gratuit",
    "pricing.tier.free.price": "0 $",
    "pricing.tier.free.tag": "Les essentiels du quotidien",
    "pricing.tier.plus.name": "Milo Plus",
    "pricing.tier.plus.price": "15 $",
    "pricing.tier.plus.tag": "Gagner du temps + alléger la charge mentale",
    "pricing.tier.premium.name": "Milo Premium",
    "pricing.tier.premium.price": "25 $",
    "pricing.tier.premium.tag": "Automatisation complète + économies",
    "pricing.group.core": "Les basiques",
    "pricing.group.smart": "Assistant intelligent",
    "pricing.group.premium_features": "Automatisation premium",
    "pricing.feat.chores": "Tâches ménagères",
    "pricing.feat.grocery_manual": "Liste de courses partagée",
    "pricing.feat.meal_basic": "Planification de repas de base",
    "pricing.feat.calendar_chat": "Calendrier et conversation familiale",
    "pricing.feat.households_1": "Familles multiples",
    "pricing.feat.ai_meals": "Planification de repas par IA",
    "pricing.feat.auto_grocery": "Liste de courses auto-générée",
    "pricing.feat.voice_actions": "Voix → actions",
    "pricing.feat.smart_reminders": "Rappels intelligents et automatisation",
    "pricing.feat.ai_quota": "Assistant IA",
    "pricing.feat.instacart": "Intégration Instacart (panier auto)",
    "pricing.feat.deals": "Optimisation des promos et coupons",
    "pricing.feat.budget": "IA avancée et budgétisation",
    "pricing.feat.insights": "Tableau de bord d'analyses",
    "pricing.val.basic": "De base",
    "pricing.val.high": "Élevé",
    "pricing.val.unlimited": "Illimité",

    // ---- Plan badges ----
    "plan.free": "Gratuit",
    "plan.plus": "Plus",
    "plan.premium": "Premium",
    "plan.trial": "Essai",

    // ---- Admin billing ----
    "admin.billing.title": "Utilisateurs et forfaits",
    "admin.billing.search": "Rechercher par courriel ou nom…",
    "admin.billing.col.user": "Utilisateur",
    "admin.billing.col.plan": "Forfait",
    "admin.billing.col.status": "Statut",
    "admin.billing.col.expires": "Expiration manuelle",
    "admin.billing.col.households": "Familles",
    "admin.billing.col.last_active": "Dernière activité",
    "admin.billing.col.actions": "Actions",
    "admin.billing.never": "Jamais",
    "admin.billing.set_plan": "Définir le forfait",
    "admin.billing.clear_expiry": "Effacer l'expiration",
    "admin.billing.updated": "Mis à jour",

    // ---- Errors ----
    "err.generic": "Une erreur est survenue. Réessayez.",
    "err.invalid_email": "Entrez un courriel valide",
    "err.couldnt_send": "Impossible d'envoyer le lien",

    // ---- Household picker ----
    "picker.creator_badge": "Créateur",
    "picker.delete_household": "Supprimer la famille",
    "picker.leave_household": "Quitter la famille",
    "picker.delete_confirm": "Cela supprimera définitivement « {name} » et TOUTES ses données (repas, tâches, courses, conversation). Tapez le nom de la famille pour confirmer :",
    "picker.delete_name_mismatch": "Le nom ne correspond pas — suppression annulée.",
    "picker.deleted": "« {name} » supprimée.",
    "picker.leave_confirm": "Quitter « {name} » ? Les autres membres continueront à la voir.",
    "picker.left": "Vous avez quitté « {name} ».",

    // ---- Invite & refer (dialogs) ----
    "invite.eyebrow": "Inviter la famille",
    "invite.join_headline": "Rejoindre {name}",
    "invite.or_share_code": "Ou partagez le code",
    "invite.share": "Partager",
    "invite.footer": "Scan → choix du prénom → c'est fait. Sans mot de passe.",
    "invite.link_copied": "Lien d'invitation copié",
    "invite.share_title": "Rejoignez {name} sur Milo",
    "invite.share_text": "Rejoignez notre famille Milo « {name} ». Code : {code}",
    "invite.share_cancelled": "Partage annulé",
    "invite.copy": "Copier",
    "invite.copied": "Copié",
    "refer.headline": "Vous aimez Milo ?",
    "refer.subline": "Partagez-le avec une autre famille",
    "refer.message": "Salut ! J'utilise Milo pour garder la maison organisée — repas, tâches, courses et chat en famille dans une seule petite app toute chaleureuse. Vous allez adorer. Essayez : {url}",
    "refer.copy_btn": "Copier le message",
    "refer.copied_btn": "Copié !",
    "refer.share_btn": "Partager",
    "refer.share_title": "Milo — le concierge discret de votre maison",
    "refer.copied": "Copié — collez-le où vous voulez",
    "refer.copy_failed": "Impossible de copier — essayez à la main",
    "refer.footer": "Merci de faire grandir Milo, une famille à la fois.",

    // ---- Set password dialog ----
    "setpw.set_headline": "Définir un mot de passe",
    "setpw.change_headline": "Changer le mot de passe",
    "setpw.set_sub": "Optionnel — connexion plus rapide la prochaine fois",
    "setpw.change_sub": "Choisissez-en un nouveau — effet immédiat",
    "setpw.new_password": "Nouveau mot de passe",
    "setpw.placeholder": "Au moins 6 caractères",
    "setpw.too_short": "Le mot de passe doit avoir au moins 6 caractères",
    "setpw.saved": "Mot de passe défini — utilisez-le la prochaine fois",
    "setpw.updated": "Mot de passe mis à jour",
    "setpw.save_failed": "Impossible d'enregistrer le mot de passe",
    "setpw.saving": "Enregistrement…",
    "setpw.save_btn": "Enregistrer",
    "setpw.update_btn": "Mettre à jour",
    "setpw.footer": "La connexion par lien magique fonctionne toujours — c'est juste un raccourci optionnel.",

    // ---- Feedback dialog ----
    "feedback.headline": "Envoyer un avis",
    "feedback.intro": "Milo est en bêta — vos retours le façonnent. Dites-nous ce qui marche, ce qui bug, ce dont vous rêvez.",
    "feedback.rating_q": "Comment ça se passe jusqu'ici ?",
    "feedback.tap_star": "Touchez une étoile",
    "feedback.rating1": "Aïe",
    "feedback.rating2": "Bof",
    "feedback.rating3": "Ça va",
    "feedback.rating4": "Super",
    "feedback.rating5": "J'adore",
    "feedback.bug_q": "Vous avez trouvé un bug ?",
    "feedback.bug_placeholder": "Décrivez ce qui ne va pas…",
    "feedback.feature_q": "Une idée de fonctionnalité ?",
    "feedback.feature_placeholder": "Qu'est-ce qui rendrait Milo encore mieux pour vous ?",
    "feedback.notes_q": "Autre chose ?",
    "feedback.notes_placeholder": "Vos pensées, vos encouragements, n'importe quoi…",
    "feedback.send_btn": "Envoyer",
    "feedback.sending": "Envoi…",
    "feedback.empty": "Ajoutez une note ou une étoile d'abord",
    "feedback.sent": "Merci — on lit chaque mot.",
    "feedback.send_failed": "Impossible d'envoyer. Réessayez.",
    "feedback.footer": "Lié à votre compte pour qu'on puisse revenir vers vous.",

    // ---- Telegram ----
    "telegram.eyebrow": "Rappels",
    "telegram.title": "Recevez des rappels sur votre téléphone",
    "telegram.intro": "Milo vous enverra un résumé quotidien et des rappels de tâches via Telegram. Pas besoin d'une autre app.",
    "telegram.no_telegram": "Vous n'avez pas Telegram ?",
    "telegram.download": "Obtenez-le ici",
    "telegram.get_link": "Activer les rappels",
    "telegram.open_telegram": "Ouvrir Telegram",
    "telegram.expires": "Le lien expire dans {min} min.",
    "telegram.connected": "Rappels activés",
    "telegram.connected_body": "Vous recevrez un résumé quotidien à 16h (heure de l'Est) et des rappels pour les tâches du jour.",
    "telegram.disconnect": "Désactiver les rappels",
    "telegram.disconnected": "Rappels désactivés",
    "telegram.confirm_disconnect": "Désactiver les rappels ?",
    "telegram.not_configured_title": "Non configuré",
    "telegram.not_configured_body": "Votre admin n'a pas encore configuré les rappels.",
};
